const collectionOfVehicles = () => import('@/pages/collectionOfVehicles')
const collectionOfVehiclesDetail = () => import('@/pages/collectionOfVehicles/detail')
const register = () => import('@/pages/collectionOfVehicles/detail/components/register')
const voidPage = () => import('@/pages/collectionOfVehicles/detail/components/void')
const unBill = () => import('@/pages/collectionOfVehicles/detail/components/unBill')
export default [
  {
    path: '/collectionOfVehicles',
    name: 'collectionOfVehicles',
    component: collectionOfVehicles,
    meta: {
      storeKey: 'oss:recycle'
    }
  },
  {
    path: '/collectionOfVehicles/detail',
    name: 'collectionOfVehiclesDetail',
    component: collectionOfVehiclesDetail
  },
  {
    path: '/collectionOfVehicles/register',
    name: 'register',
    component: register
  },
  {
    path: '/collectionOfVehicles/void',
    name: 'void',
    component: voidPage
  },
  {
    path: '/collectionOfVehicles/unBill',
    name: 'unBill',
    component: unBill
  }
]



// WEBPACK FOOTER //
// ./src/router/collectionOfVehicles/index.js